(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oreilly-cart-collections"] && !Shopify.designMode) return;
  try {
    (() => {
    const readLines = (source) =>
      JSON.parse(source.textContent).map((line) => ({
        product: { id: line.id, handle: line.handle, title: line.title },
        // Map the full Liquid arrays without a for-loop's 50-iteration limit.
        collections: (line.collection_handles || []).map((handle, index) => ({
          id: String(line.collection_ids[index]),
          handle,
          title: line.collection_titles[index],
        })),
      }));

    const publishLineEvents = (eventName, lines) => {
      window.dataLayer = window.dataLayer || [];
      lines.forEach((line) => {
        window.dataLayer.push({ oreilly_product: line.product, oreilly_collection: null });
        line.collections.forEach((collection) => {
          window.dataLayer.push({ event: eventName, oreilly_collection: collection });
        });
      });
    };

    const publishCart = () => {
      const source = document.querySelector('[data-oreilly-cart-collections]');
      if (!source || source.dataset.initialized === 'true') return;
      source.dataset.initialized = 'true';

      const lines = readLines(source);
      if (!lines.length) return;

      publishLineEvents('oreilly_product_collection_view_cart', lines);

      document.querySelectorAll('button[name="checkout"]').forEach((button) => {
        button.addEventListener(
          'click',
          () => publishLineEvents('oreilly_product_collection_begin_checkout', lines),
          { once: true },
        );
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', publishCart, { once: true });
    } else {
      publishCart();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oreilly-product-collections"] && !Shopify.designMode) return;
  try {
    (() => {
    const publishCollectionEvents = (eventName, collections) => {
      window.dataLayer = window.dataLayer || [];
      collections.forEach((collection) => {
        window.dataLayer.push({
          event: eventName,
          oreilly_collection: collection,
        });
      });
    };

    // The product section changes the Add to Cart label to "Added" only after /cart/add succeeds.
    const watchAddToCart = (collections) => {
      const button = document.getElementById('oreilly-atc');
      if (!button || !window.MutationObserver) return;

      let added = false;
      new window.MutationObserver(() => {
        const isAdded = button.textContent.trim().indexOf('Added') === 0;
        if (isAdded && !added) {
          publishCollectionEvents('oreilly_product_collection_add_to_cart', collections);
        }
        added = isAdded;
      }).observe(button, { childList: true, characterData: true, subtree: true });
    };

    const publishCollections = () => {
      const source = document.querySelector('[data-oreilly-product-collections]');
      if (!source || source.dataset.initialized === 'true') return;

      const data = JSON.parse(source.textContent);
      // Map the full Liquid arrays without a for-loop's 50-iteration limit.
      const collections = data.collection_handles.map((handle, index) => ({
        id: String(data.collection_ids[index]),
        handle,
        title: data.collection_titles[index],
      }));
      source.dataset.initialized = 'true';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        oreilly_product: { id: data.id, handle: data.handle, title: data.title, collections },
        oreilly_collection: null,
      });
      publishCollectionEvents('oreilly_product_collection_view', collections);
      watchAddToCart(collections);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', publishCollections, { once: true });
    } else {
      publishCollections();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
